import { apiService } from './api'
import { adminAuthService } from './adminAuth'

/**
 * 관리자 API 호출의 공통 부분.
 *
 * 화면마다 fetch 와 인증 헤더 헬퍼를 따로 들고 있었다. 그 탓에
 * - /api 접두사를 직접 붙이거나 빠뜨려 운영에서 백엔드에 닿지 않고
 * - 어떤 호출은 인증 헤더를 아예 빠뜨리는
 * 문제가 섞여 있었다. 경로와 인증을 여기 한 곳에서만 정한다.
 */

/** 관리자 토큰을 붙인 요청 설정 */
export function adminAuthConfig(extra: Record<string, unknown> = {}) {
  const token = adminAuthService.getToken()
  if (!token) {
    throw new Error('No admin token available')
  }
  return { ...extra, headers: { Authorization: `Bearer ${token}` } }
}

/** success:false 를 서버 메시지와 함께 예외로 올린다 */
export function unwrap<T>(
  body: any,
  pick: (body: any) => T,
  fallback: string
): T {
  if (!body?.success) {
    throw new Error(body?.message || fallback)
  }
  return pick(body)
}

export const adminHttp = {
  async get<T>(path: string, pick: (b: any) => T, fail: string, params?: any) {
    const { data } = await apiService.client.get(
      path,
      adminAuthConfig(params ? { params } : {})
    )
    return unwrap(data, pick, fail)
  },
  async post<T>(path: string, body: any, pick: (b: any) => T, fail: string) {
    const { data } = await apiService.client.post(path, body, adminAuthConfig())
    return unwrap(data, pick, fail)
  },
  async put<T>(path: string, body: any, pick: (b: any) => T, fail: string) {
    const { data } = await apiService.client.put(path, body, adminAuthConfig())
    return unwrap(data, pick, fail)
  },
  async patch<T>(path: string, body: any, pick: (b: any) => T, fail: string) {
    const { data } = await apiService.client.patch(
      path,
      body,
      adminAuthConfig()
    )
    return unwrap(data, pick, fail)
  },
  async delete<T>(path: string, pick: (b: any) => T, fail: string) {
    const { data } = await apiService.client.delete(path, adminAuthConfig())
    return unwrap(data, pick, fail)
  },
}

export default adminHttp
